export default "__VITE_ASSET__CY_agLwk__"